import type { Phrase } from '../types';
import type { venueEn } from './venue.en';

export const venueMl: Partial<Record<keyof typeof venueEn, Phrase>> = {
  // page chrome
  vnBackToVenues: 'എല്ലാ വേദികളും',
  vnNotFoundTitle: 'ഈ വേദി കണ്ടെത്താനായില്ല',
  vnNotFoundBody: 'ഇത് നീക്കം ചെയ്തിരിക്കാം, അല്ലെങ്കിൽ ഇപ്പോൾ ബുക്കിംഗ് സ്വീകരിക്കുന്നില്ല.',
  vnBrowseVenues: 'വേദികൾ കാണുക',
  vnSave: 'സേവ് ചെയ്യുക',
  vnSaved: 'സേവ് ചെയ്തു',

  // gallery
  vnViewAllPhotos: { one: 'ഫോട്ടോ കാണുക', other: 'എല്ലാ {count} ഫോട്ടോകളും കാണുക' },
  vnOpenPhoto: '{name} — {count} ഫോട്ടോകളിൽ {index}-ാമത്തേത് തുറക്കുക',
  vnNoPhotos: 'വേദി ഇതുവരെ ഫോട്ടോകൾ ചേർത്തിട്ടില്ല',
  vnView360: '360° കാഴ്ച',
  vn360Slide: '360° കാഴ്ച · ചുറ്റും കാണാൻ വലിക്കുക',

  // header
  vnInBuilding: '{name} ന്റെ ഭാഗം',
  vnCheckAvailability: 'ലഭ്യത പരിശോധിക്കുക',
  vnStatGuests: 'അതിഥികൾ',
  vnStatGuestsAll: 'ആകെ അതിഥികൾ',
  vnStatGuestsSplit: '{seated} ഇരിപ്പിടം · {standing} നിൽക്കുന്നവർ',
  vnStatFrom: 'തുടക്ക നിരക്ക്',
  vnStatOnRequest: 'അന്വേഷിക്കുക',
  vnStatRooms: 'മുറികൾ',
  vnStatParking: 'പാർക്കിംഗ്',
  vnStatNone: 'നൽകിയിട്ടില്ല',

  // section nav
  vnNavOverview: 'അവലോകനം',
  vnNavFacilities: 'സൗകര്യങ്ങൾ',
  vnNavCapacity: 'ശേഷി',
  vnNavPricing: 'നിരക്കുകൾ',
  vnNavLocation: 'സ്ഥലം',
  vnNavReviews: 'അഭിപ്രായങ്ങൾ',

  // about
  vnAboutTitle: 'വേദിയെക്കുറിച്ച്',
  vnAboutFallback: '{count} പേർക്ക് ഇരിപ്പിടമുള്ള ഒരു {category} ആണ് {name}.',
  vnAboutFallbackPlace: '{place}-ൽ {count} പേർക്ക് ഇരിപ്പിടമുള്ള ഒരു {category} ആണ് {name}.',
  vnGoodFor: 'അനുയോജ്യം',
  vnGoodForNote: 'ഇത്തരം വേദികളിൽ സാധാരണ നടക്കുന്ന പരിപാടികൾ. നിങ്ങളുടെ പരിപാടിക്ക് യോജിക്കുമോ എന്ന് വേദിയോട് ചോദിച്ച് ഉറപ്പാക്കുക.',
  vnEquipTitle: 'പരിപാടികൾക്ക് നൽകുന്ന ഉപകരണങ്ങൾ',

  // facilities
  vnFacilitiesTitle: 'വേദി നൽകുന്നവ',
  vnFacAc: 'എയർ കണ്ടീഷൻ ചെയ്തത്',
  vnFacLift: 'ലിഫ്റ്റ് സൗകര്യം',
  vnFacCatering: 'കാറ്ററിംഗ്: {value}',
  vnFacCuisine: 'ഭക്ഷണം: {value}',
  vnFacEstablished: '{year}-ൽ സ്ഥാപിച്ചത്',
  vnFacAmenities: 'വേദിയിലെ മറ്റ് സൗകര്യങ്ങൾ',

  // capacity
  vnCapacityTitle: 'സ്ഥലവും ഇരിപ്പിടവും',
  vnSeated: 'ഇരിപ്പിടം',
  vnFloating: 'നിൽക്കുന്നവർ',
  vnTotalGuests: 'ആകെ അതിഥി ശേഷി',

  // pricing
  vnPricingTitle: 'നിരക്കുകളും നിബന്ധനകളും',
  vnPerHour: 'മണിക്കൂറിന്',
  vnHalfDay: 'സെഷൻ',
  vnFullDay: 'മുഴുവൻ ദിവസം',
  vnNotOffered: 'ലഭ്യമല്ല',
  vnWeekend: 'വാരാന്ത്യ നിരക്ക് (ശനി, ഞായർ)',
  vnWeekendVal: 'സാധാരണ ദിവസങ്ങളേക്കാൾ {percent}% കൂടുതൽ',
  vnWeekendSame: 'എല്ലാ ദിവസവും ഒരേ നിരക്ക്',
  vnBuffer: 'ബുക്കിംഗുകൾക്കിടയിലെ വൃത്തിയാക്കൽ ഇടവേള',
  vnBufferVal: { one: '{count} മിനിറ്റ് ഒഴിച്ചിടും', other: '{count} മിനിറ്റ് ഒഴിച്ചിടും' },
  vnBufferHelp:
    'ഓരോ ബുക്കിംഗിനും മുമ്പും ശേഷവും വൃത്തിയാക്കാനും ഒരുക്കാനും ഈ സമയം ഒഴിച്ചിടും. ഈ ഇടവേള കഴിഞ്ഞേ അടുത്ത ബുക്കിംഗ് തുടങ്ങാനാകൂ, അതിനാൽ മറ്റൊരു ബുക്കിംഗിനോട് ചേർന്നുള്ള സമയം ബുക്ക് ചെയ്യാനാകില്ല.',
  vnBufferNone: 'ബുക്കിംഗുകൾക്കിടയിൽ ഇടവേള ആവശ്യമില്ല',
  vnPayVenue: 'പണം നേരിട്ട് വേദിക്ക് നൽകുക. Aghosha-യിൽ ഒന്നും അടയ്ക്കേണ്ടതില്ല.',
  vnVenueConfirms: 'ഓരോ അഭ്യർത്ഥനയും ബുക്കിംഗ് ആകുന്നതിന് മുമ്പ് വേദി സ്ഥിരീകരിക്കും.',
  vnExactPrice: 'സമയം തിരഞ്ഞെടുത്താലുടൻ നിങ്ങളുടെ തീയതിയുടെ കൃത്യമായ തുക കാണിക്കും.',

  // availability panel
  vnAvailTitle: 'തീയതികൾ പരിശോധിക്കുക',
  vnAvailBody: 'തത്സമയ ലഭ്യത. തിരഞ്ഞെടുക്കുമ്പോൾ നിരക്ക് മാറും.',
  vnContinue: 'ബുക്കിംഗിലേക്ക് തുടരുക',
  vnLoginToContinue: 'തുടരാൻ ലോഗിൻ ചെയ്യുക',
  vnStaffNoBook: 'വേദി ജീവനക്കാരുടെ അക്കൗണ്ടുകൾക്ക് ബുക്കിംഗ് അഭ്യർത്ഥിക്കാനാവില്ല. ബുക്ക് ചെയ്യാൻ അതിഥി അക്കൗണ്ടിൽ ലോഗിൻ ചെയ്യുക.',

  // location
  vnLocationTitle: 'എവിടെയാണ്',
  vnGetDirections: 'വഴി കാണുക',
  vnOpensMaps: 'Google Maps പുതിയ ടാബിൽ തുറക്കും',
  vnMapTitle: '{name} കാണിക്കുന്ന മാപ്പ്',
  vnMapApprox: 'വേദി സ്ഥലപ്പേര് മാത്രമേ നൽകിയിട്ടുള്ളൂ, അതിനാൽ മാപ്പിൽ ആ പ്രദേശം കാണിക്കുന്നു. കൃത്യമായ സ്ഥലം വേദിയോട് ചോദിക്കുക.',

  // reviews
  vnReviewsTitle: 'അതിഥികൾ പറയുന്നത്',
  vnBasedOn: { one: '{count} അഭിപ്രായത്തെ അടിസ്ഥാനമാക്കി', other: '{count} അഭിപ്രായങ്ങളെ അടിസ്ഥാനമാക്കി' },
  vnNoReviewsBody: 'പരിപാടിക്ക് ശേഷം അതിഥികൾക്ക് വേദിയെക്കുറിച്ച് അഭിപ്രായം എഴുതാം.',

  // contact
  vnContactEyebrow: 'ബന്ധപ്പെടുക',
  vnContactTitle: 'ബുക്ക് ചെയ്യുന്നതിന് മുമ്പ് സംശയങ്ങളുണ്ടോ?',
  vnContactBody: 'വേദിയെ വിളിക്കുകയോ സന്ദേശം അയയ്ക്കുകയോ ചെയ്യുക, അല്ലെങ്കിൽ ഒരു അന്വേഷണം അയയ്ക്കുക — അവർ മറുപടി നൽകും.',
  vnEnquiryTitle: 'അന്വേഷണം അയയ്ക്കുക',

  // related
  vnSameBuildingEyebrow: 'ഒരേ കെട്ടിടം',
  vnSimilarEyebrow: 'നിങ്ങൾക്ക് ഇഷ്ടപ്പെട്ടേക്കാം',
  // night edition
  vnBookingType: 'ബുക്കിംഗ് രീതി',
  vnCarPrev: 'മുമ്പത്തെ വേദികൾ',
  vnCarNext: 'അടുത്ത വേദികൾ',
  vnEnqName: 'നിങ്ങളുടെ പേര്',
  vnEnqPhone: 'മൊബൈൽ നമ്പർ',
  vnEnqEmail: 'ഇമെയിൽ (നിർബന്ധമില്ല)',
  vnEnqDate: 'പരിപാടിയുടെ തീയതി',
  vnEnqGuests: 'അതിഥികൾ',
  vnEnqGuestsPh: 'ഏകദേശം',
  vnEnqMessage: 'സന്ദേശം',
  vnEnqSentTitle: 'അന്വേഷണം അയച്ചു',
  vnEnqSentBody: '{name} ഫോണിലോ SMS വഴിയോ മറുപടി നൽകും.',
  vnEnqAnother: 'മറ്റൊരു അന്വേഷണം അയയ്ക്കുക',
  vnReviewBy: 'അതിഥിയുടെ അഭിപ്രായം',
};
